// @ts-nocheck
export default class IncorrectPasswordError extends Error {}
